export enum NotificationTypes {
  COMMON = 'common',
  CALL = 'call',
  MENTION = 'mention',
  OVERDUE_TO_DO = 'overdueToDo',
  /** Notify v2: to-do due today (morning reminder); old notifiers never send it */
  DUE_TO_DO = 'dueToDo',
  TO_DO_ASSIGNED = 'toDoAssigned',
  TO_DO_COMPLETED = 'toDoCompleted',
  ENTITY_ASSIGNED_TO_SUPERVISOR = 'employeeAssignedToSupervisor',
  SUPERVISED_ENTITY_DEACTIVATED = 'supervisedEntityDeactivated',
  WHATSAPP_MESSAGE_TEMPLATE_STATUS_UPDATE = 'whatsappMessageTemplateStatusUpdate',
  COURSE_CANCELLATION_FAILED = 'courseCancellationFailed',
  HANDOUT_EVENT_FEEDBACK = 'handoutEventFeedback',
  /** Morning reminder (Mon–Fri 07:30) about lessons whose course logs are missing; old notifiers never send it */
  MISSING_COURSE_LOGS = 'missingCourseLogs',
  /** Answer / state change of a takeover offer ("Dauerhafte Übernahme anbieten") for sender and Standort supervisor */
  TAKEOVER_OFFER_UPDATE = 'takeoverOfferUpdate',
}
